module.exports = __webpack_public_path__ + "static/img/take-picture1.e007918.png";